import { render, staticRenderFns } from "./MainDraw.vue?vue&type=template&id=a02d0512&scoped=true&"
import script from "./MainDraw.vue?vue&type=script&lang=js&"
export * from "./MainDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02d0512",
  null
  
)

export default component.exports